<div
  class="stream row align-center w100 gap-8"
  *ngFor="let stream of track.streams"
>
  <rr-icon name="wind"></rr-icon>
  <div class="name">{{ stream.name }}</div>

  <div class="actionrow row gap-24 grow-1 justify-end align-center">
    <rr-icon
      name="trash"
      color="nutral"
      class="pointer"
      (click)="deleteStream(stream.id)"
    ></rr-icon>
    <rr-btn
      type="Link"
      size="medium"
      class="underline"
      [routerLink]="'/home/streams/' + stream.id"
      >Edit</rr-btn
    >
  </div>
</div>
<rr-spinner *ngIf="!hidespinner"></rr-spinner>
